import moment from "moment";
import React from "react";
import {SegmentedControl} from "segmented-control";

import ActionBar from "../components/ActionBar";
import Loader from "../components/Loader";
import MatrixView from "../components/MatrixView";
import VLButton from "../components/VLButton";
import Sensor from "../Sensor";
import * as API from "../util/api";
import * as Provider from "../util/provider";

import * as Util from "../util/util";
import * as Variant from "../util/variant";
import VLComponent from "./VLComponent";

export default class MatrixScreen extends VLComponent {

    constructor() {
        super();
        this.matrixRef = React.createRef();
        let columns = parseInt(localStorage.getItem("mat-cols"));
        if (isNaN(columns) || columns == null || columns < 2 || columns > 8) {
            columns = 4;
        }

        this.state = {
            loaded: false,
            sensors: [],
            groups: [],
            sort: 0,
            search: "",
            variant: 0,
            columns,
            customMatrices: [],
            viewingGroup: 0,
            hideBack: Util.isSubAccount() || Util.isCommunity()
        };
    }

    componentDidMount() {
        if (this.props.group) {
            this.setState({viewingGroup: this.props.group});
        }

        if (!Util.isCommunity()) {
            API.POST("groups/list", {}, result => {
                if (result.success) {
                    this.setState({
                        groups: result.result.groups.map(g => g.name),
                        offline: result.result.sensors_offline
                    });
                }
            });
        }

        this.reload();
        let minute = 60 * 1000;
        setInterval(this.reload, 2 * minute);

        Util.getLocation((pos) => {
            this.setState({lat: pos.coords.latitude, lng: pos.coords.longitude});
        });
    }

    groupOptionChanged = (e) => {
        this.handleInputChange(e, () => {
            let g = this.groupOptions()[this.state.viewingGroup];
            let link = (g.type == 1 ? "/matrix/" : "/customMatrix/") + g.id;
            //Util.logHistory("Matrix " + g.name, link);
        });
    };

    reload = () => {
        let loaded = result => {
            Util.handleLogout(result);
            if (result.success) {
                localStorage.setItem("vl-isSubAccount", result.result.isSubAccount);
                let sensors = result.result.sensors;

                this.setState({customMatrices: result.result.matrices}, () => {
                    if (this.props.customId && !this.hasLoadedCustom) {
                        this.hasLoadedCustom = true;
                        this.groupOptions().forEach((g, i) => {
                            if (g.type == 2 && g.id == this.props.customId) {
                                this.setState({viewingGroup: i});
                            }
                        });
                    }
                });

                this.setState({hideBack: (Util.isSubAccount() || Util.isCommunity())});
                this.setState(result.result);
                this.setState({refreshTime: moment().format("HH:mm:ss")});
                this.setState({loaded: true});
            }
        };
        if (!Util.isCommunity()) {
            API.POST("systems/list", {show_ea: true}, loaded);
        } else {
            API.POST("systems/communityList", {}, loaded);
        }
    };

    render() {
        return (
            <div>
                <ActionBar title={this.state.app_name} hideBack={this.state.hideBack}/>
                <div id="content" style={{width: "100%", display: this.state.loaded ? "block" : "none"}}>
                    {this.renderFilters()}
                    <div style={{height: "calc(100vh - 128px)", overflowY: "auto"}}>
                        <MatrixView ref={this.matrixRef} images={this.getImages()} columns={this.state.columns}/>
                    </div>
                </div>

                <Loader loaded={this.state.loaded}/>
            </div>
        );
    }

    groupOptions = () => {
        //all groups and all matrices
        //type 1 is group, type 2 is matrix
        if (Util.isCommunity()) {
            return [{type: 1, name: "All", id: 0}];
        }
        let r = [];
        this.state.groups.forEach((g, i) => {
            if (g != null && g != "null") {
                r.push({type: 1, name: g, id: i});
            }
        });
        this.state.customMatrices.forEach(m => {
            r.push({type: 2, name: m.name, id: m.id, cameras: m.cameras});
        });

        return r;
    };

    getImages = () => {
        return this.displaying().map(system => {
            Object.setPrototypeOf(system, Sensor.prototype);
            let title = system.sensor_name + " - " + moment.unix(system.sensor_comms_unix).format("DD MMM HH:mm");
            let id = system.sensor_id;
            let url = system.small_image;
            let graph_data = system.graph_data;
            let background = system.getBackground();
            let overlay = (system.ea || system.online) ? null : "OFFLINE";
            let link = (system.variant != Variant.GAUGE ? "/camera/" : "/sensor/") + (system.provider != Provider.VL ? system.provider + "/" : "") + system.sensor_id;
            if (system.head != 0 && system.head != null) {
                link += "/head/" + system.head;
            }
            let onClick = () => this.props.navigate(link);
            let type = system.variant != Variant.GAUGE ? "" : "sensor";
            return {
                ...system,
                id,
                title,
                url,
                background,
                overlay,
                onClick,
                graph_data,
                type,
                provider: system.provider,
                mini_icon: system.multi_image ? "add_to_photos" : (system.variant == Variant.IP_CAMERA ? "wifi" : "")
            };
        });
    };

    clearFilters = () => {
        this.setState({search: ""});
    };

    renderFilters = () => {
        let groups = this.state.groups.filter(g => g != null && g != "");
        if (groups.length < 1 && !Util.isCommunity()) {
            return;
        }

        let showingSens = this.state.sensors.filter(s => {
            return this.isInCurrentGroup(s);
        });
        let numCam = showingSens.filter(s => s.variant == Variant.CAMERA).length;
        let numRtu = showingSens.filter(s => s.variant == Variant.GAUGE).length;
        let numIp = showingSens.filter(s => s.variant == Variant.IP_CAMERA).length;

        let types = [
            {label: `All (${showingSens.length})`, value: "0", default: this.state.variant == 0},
            {label: `GSM Cam (${numCam})`, value: "1", default: this.state.variant == Variant.CAMERA},
            {label: `Gauge (${numRtu})`, value: "2", default: this.state.variant == Variant.GAUGE},
            {label: `IP Cam (${numIp})`, value: "3", default: this.state.variant == Variant.IP_CAMERA}
        ];
        return (
            <div style={{padding: "0 16px"}}>
                <div style={{display: "flex", alignItems: "center"}}>

                    {this.groupPicker()}

                    <SegmentedControl
                        name="variant"
                        options={types}
                        value={this.state.variant}
                        setValue={variant => this.setState({variant})}
                        style={{flex: 1, color: window.primary, margin: 8}}/>

                    <p>Refreshed: {this.state.refreshTime}</p>
                    <VLButton onClick={this.zoomOut} title="-"/>
                    <p>Zoom</p>
                    <VLButton onClick={this.zoomIn} title="+"/>
                </div>
            </div>
        );
    };

    groupPicker = () => {
        if (Util.isCommunity()) {
            return;
        }
        return <div style={{display: "flex", width: 140}}>
            <select style={{width: "100%"}} value={this.state.viewingGroup} name="viewingGroup"
                    onChange={this.groupOptionChanged}>
		    {this.groupOptions().map((opt, i) => {
  			if (!opt || !opt.name || opt.name.trim() === '') return null;
			  return <option key={i} value={i}>{opt.name}</option>;
			})
		    }
            </select>
        </div>;
    };

    zoomOut = () => {
        let columns = Math.min(this.state.columns + 1, 8);
        this.setState({columns});
        localStorage.setItem("mat-cols", columns);
    };

    zoomIn = () => {
        let columns = Math.max(this.state.columns - 1, 2);
        this.setState({columns});
        localStorage.setItem("mat-cols", columns);
    };

    isInCurrentGroup = (sensor) => {
        let group = this.groupOptions()[this.state.viewingGroup];
        if (group.type == 1 && group.id == 0) {
            //All Systems
            return sensor.provider == Provider.VL;
        } else if (group.type == 1) {
            //this is a group so check the system_group
            return sensor.system_group == group.id;
        }
        //custom matrix
        return group.cameras.indexOf(sensor.sensor_id) != -1;
    };

    displaying = () => {
        let base = this.state.sensors.filter(s => {
            return this.isInCurrentGroup(s);
        }).filter(s => {
            return s.variant == this.state.variant || this.state.variant == 0;
        }).filter(s => {
            Object.setPrototypeOf(s, Sensor.prototype);
            return s.matches(this.state.search);
        });

        let sensors = [];
        //add hi res and twin heads
        base.forEach(s => {
            Object.setPrototypeOf(s, Sensor.prototype);
            if (s.isHiRes()) {
                let hires = s.hi_res_sensor;
                Object.setPrototypeOf(hires, Sensor.prototype);
                hires.sensor_name = s.sensor_name;
                hires.sensor_id = s.sensor_id;
                hires.online = s.online;
                hires.sensor_comms = s.sensor_comms;
                hires.sensor_comms_unix = s.sensor_comms_unix;
                hires.variant = Variant.GAUGE;
                hires.provider = s.provider;
                sensors.push(hires);
            }
            if (s.variant != Variant.GAUGE) {
                //camera, use images array
                if (s.sensor_images.length > 1) {
                    s.multi_image = true;
                }
                s.sensor_images.forEach((im, index) => {
                    let other = {...s};
                    Object.setPrototypeOf(other, Sensor.prototype);
                    const isntOld = (Util.rn() - im.unix) < 24 * 60 * 60;
                    other.sensor_image = im.image;
                    other.small_image = im.small_image;
                    other.sensor_comms_unix = im.unix;
                    other.head = index;
                    other.online = other.online && isntOld;
                    sensors.push(other);
                });
            } else {
                sensors.push(s);
            }
        });

        return sensors.sort((a, b) => {
            if (a.isOnlineForSortingPurposes() && !b.isOnlineForSortingPurposes()) {
                return 1;
            }
            if (b.isOnlineForSortingPurposes() && !a.isOnlineForSortingPurposes()) {
                return -1;
            }
            if (a.sensor_name < b.sensor_name) {
                return -1;
            }
            return 1;
        });
    };

}
